unit Country;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, VCL.TMSFNCTypes,
  VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, VCL.TMSFNCCustomControl,
  VCL.TMSFNCDataGrid, WEBLib.Buttons, Vcl.StdCtrls, WEBLib.StdCtrls, Data.DB,
  WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client,
  VCL.TMSFNCCustomComponent, VCL.TMSFNCDataGridDatabaseAdapter,
  VCL.TMSFNCBitmapContainer;

type
  TfrmCountry = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebButton1: TButton;
    WebPanel4: TPanel;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton3: TSpeedButton;
    WebSpeedButton4: TSpeedButton;
    WebSpeedButton5: TSpeedButton;
    dgCountry: TTMSFNCDataGrid;
    wcCountry: TXDataWebClient;
    wdsCountry: TXDataWebDataSet;
    dsCountry: TDataSource;
    dgdbaCountry: TTMSFNCDataGridDatabaseAdapter;
    TMSFNCBitmapContainer1: TTMSFNCBitmapContainer;
    WebButton2: TButton;
    WebSpeedButton6: TSpeedButton;
    WebSpeedButton7: TSpeedButton;
    edtCountryPC: TEdit;
    WebSpeedButton8: TSpeedButton;
    WebSpeedButton9: TSpeedButton;
    wdsCountryno: TIntegerField;
    wdsCountryName: TStringField;
    procedure WebSpeedButton6Click(Sender: TObject);
    procedure WebSpeedButton7Click(Sender: TObject);
    procedure WebSpeedButton8Click(Sender: TObject);
    procedure WebSpeedButton9Click(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure dgCountryCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure WebButton1Click(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure WebSpeedButton5Click(Sender: TObject);
  private
    { Private declarations }

    iCountryPC , iCountryMaxPC : Integer;



    procedure LoadCountry;

  public
    { Public declarations }

    sCountry : String;
    iLoadCountryNo : Integer;
  protected procedure LoadDFMValues; override; end;

var
  frmCountry: TfrmCountry;

implementation

{$R *.dfm}
uses
  share.classes,share.common, stfmssystem.connection, ContractSetup;

{ TfrmCountry }

procedure TfrmCountry.dgCountryCellClick(Sender: TObject; AColumn,
  ARow: Integer);
begin
  sCountry := dgdbaCountry.FieldAtColumn[1].AsString;
  iLoadCountryNo := dgdbaCountry.FieldAtColumn[0].AsInteger;
end;

procedure TfrmCountry.LoadCountry;
var
  sJsonParams : string;
  procedure OnError(Error: TXDataClientError);
    begin
      LoadCountry;
    end;
  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadCountry;
        end
      else
        begin
          wdsCountry.Close;
          wdsCountry.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsCountry.Open;

          console.log(GetJsonFromDataSet(wdsCountry));
        end;
    end;

  procedure OnSuccessPC(Response : TXDataClientResponse);
    var
    CountryParmas : TCountryParmas;
    begin
      iCountryMaxPC := Integer(TJSObject(Response.Result)['value']);

      edtCountryPC.Text := IntToStr(iCountryPC) + ' of ' + IntToStr(iCountryMaxPC);

      CountryParmas := TCountryParmas.Create;
      CountryParmas.PageCount := iCountryPC;

      sJsonParams := ConvertObjToJson(CountryParmas).ToJSON;

      console.log(sJsonParams);

      wcCountry.RawInvoke('IstfmsloadsService.Get_Country_View',[sJsonParams],@OnSuccess,@OnError);


    end;
begin
  wcCountry.RawInvoke('IstfmsloadsService.Get_Country_MaxPC',[],@OnSuccessPC,@OnError);
end;

procedure TfrmCountry.WebButton1Click(Sender: TObject);
begin
  sCountry := '';
  Close;
end;

procedure TfrmCountry.WebButton2Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmCountry.WebFormShow(Sender: TObject);
begin
  iCountryPC := 1;

  LoadCountry;
end;

procedure TfrmCountry.WebSpeedButton5Click(Sender: TObject);
var
  newform : TfrmCountrySetup;
  sCountry : String;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      ShowMessage('Country Successfully Saved');
      LoadCountry;
    end;
  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
    end;
begin
  sCountry := InputBox('Country','Enter a new Country','');

  wdsCountry.Insert;
  wdsCountry.FieldByName('Name').AsString := sCountry;

  wcCountry.RawInvoke('IstfmsloadsService.Put_Country_Insert',[GetJsonFromDataSet(wdsCountry)],@OnSuccess,@OnError);
end;

procedure TfrmCountry.WebSpeedButton6Click(Sender: TObject);
begin
  iCountryPC := 1;

  LoadCountry;
end;

procedure TfrmCountry.WebSpeedButton7Click(Sender: TObject);
begin
  if iCountryPC > 1 then
    Begin
      Dec(iCountryPC);
      LoadCountry;
    End;
end;

procedure TfrmCountry.WebSpeedButton8Click(Sender: TObject);
begin
  if iCountryPC < iCountryMaxPC then
    Begin
      Inc(iCountryPC);
      LoadCountry;
    End;
end;

procedure TfrmCountry.WebSpeedButton9Click(Sender: TObject);
begin
  iCountryPC := iCountryMaxPC;
  LoadCountry;
end;

procedure TfrmCountry.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  TMSFNCBitmapContainer1 := TTMSFNCBitmapContainer.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebSpeedButton6 := TSpeedButton.Create(Self);
  WebSpeedButton7 := TSpeedButton.Create(Self);
  edtCountryPC := TEdit.Create(Self);
  WebSpeedButton8 := TSpeedButton.Create(Self);
  WebSpeedButton9 := TSpeedButton.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  dgCountry := TTMSFNCDataGrid.Create(Self);
  dgdbaCountry := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  wcCountry := TXDataWebClient.Create(Self);
  wdsCountry := TXDataWebDataSet.Create(Self);
  wdsCountryno := TIntegerField.Create(Self);
  wdsCountryName := TStringField.Create(Self);
  dsCountry := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  TMSFNCBitmapContainer1.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebSpeedButton6.BeforeLoadDFMValues;
  WebSpeedButton7.BeforeLoadDFMValues;
  edtCountryPC.BeforeLoadDFMValues;
  WebSpeedButton8.BeforeLoadDFMValues;
  WebSpeedButton9.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  dgCountry.BeforeLoadDFMValues;
  dgdbaCountry.BeforeLoadDFMValues;
  wcCountry.BeforeLoadDFMValues;
  wdsCountry.BeforeLoadDFMValues;
  wdsCountryno.BeforeLoadDFMValues;
  wdsCountryName.BeforeLoadDFMValues;
  dsCountry.BeforeLoadDFMValues;
  try
    Name := 'frmCountry';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 640;
    WebPanel1.Height := 480;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 640;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'Country Information';
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    TMSFNCBitmapContainer1.SetParentComponent(WebPanel2);
    TMSFNCBitmapContainer1.Name := 'TMSFNCBitmapContainer1';
    TMSFNCBitmapContainer1.Left := 512;
    TMSFNCBitmapContainer1.Top := 16;
    TMSFNCBitmapContainer1.Width := 26;
    TMSFNCBitmapContainer1.Height := 26;
    TMSFNCBitmapContainer1.Visible := True;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 420;
    WebPanel3.Width := 640;
    WebPanel3.Height := 60;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 1;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 130;
    WebButton1.Top := 16;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Close';
    WebButton1.Color := clRed;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 16;
    WebButton2.Top := 16;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Select';
    WebButton2.Color := clGreenyellow;
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebSpeedButton6.SetParentComponent(WebPanel3);
    WebSpeedButton6.Name := 'WebSpeedButton6';
    WebSpeedButton6.Left := 248;
    WebSpeedButton6.Top := 16;
    WebSpeedButton6.Width := 24;
    WebSpeedButton6.Height := 24;
    WebSpeedButton6.Caption := '<<';
    WebSpeedButton6.Color := clNone;
    WebSpeedButton6.HeightPercent := 100.000000000000000000;
    WebSpeedButton6.TabOrder := 2;
    WebSpeedButton6.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton6, Self, 'OnClick', 'WebSpeedButton6Click');
    WebSpeedButton7.SetParentComponent(WebPanel3);
    WebSpeedButton7.Name := 'WebSpeedButton7';
    WebSpeedButton7.Left := 278;
    WebSpeedButton7.Top := 16;
    WebSpeedButton7.Width := 24;
    WebSpeedButton7.Height := 24;
    WebSpeedButton7.Caption := '<';
    WebSpeedButton7.Color := clNone;
    WebSpeedButton7.HeightPercent := 100.000000000000000000;
    WebSpeedButton7.TabOrder := 3;
    WebSpeedButton7.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton7, Self, 'OnClick', 'WebSpeedButton7Click');
    edtCountryPC.SetParentComponent(WebPanel3);
    edtCountryPC.Name := 'edtCountryPC';
    edtCountryPC.Left := 308;
    edtCountryPC.Top := 16;
    edtCountryPC.Width := 60;
    edtCountryPC.Height := 22;
    edtCountryPC.Alignment := taCenter;
    edtCountryPC.ChildOrder := 7;
    edtCountryPC.HeightPercent := 100.000000000000000000;
    edtCountryPC.Text := '1 of 1';
    edtCountryPC.WidthPercent := 100.000000000000000000;
    WebSpeedButton8.SetParentComponent(WebPanel3);
    WebSpeedButton8.Name := 'WebSpeedButton8';
    WebSpeedButton8.Left := 374;
    WebSpeedButton8.Top := 16;
    WebSpeedButton8.Width := 24;
    WebSpeedButton8.Height := 24;
    WebSpeedButton8.Caption := '>';
    WebSpeedButton8.Color := clNone;
    WebSpeedButton8.HeightPercent := 100.000000000000000000;
    WebSpeedButton8.TabOrder := 5;
    WebSpeedButton8.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton8, Self, 'OnClick', 'WebSpeedButton8Click');
    WebSpeedButton9.SetParentComponent(WebPanel3);
    WebSpeedButton9.Name := 'WebSpeedButton9';
    WebSpeedButton9.Left := 404;
    WebSpeedButton9.Top := 16;
    WebSpeedButton9.Width := 24;
    WebSpeedButton9.Height := 24;
    WebSpeedButton9.Caption := '>>';
    WebSpeedButton9.Color := clNone;
    WebSpeedButton9.HeightPercent := 100.000000000000000000;
    WebSpeedButton9.TabOrder := 6;
    WebSpeedButton9.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton9, Self, 'OnClick', 'WebSpeedButton9Click');
    WebPanel4.SetParentComponent(WebPanel1);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 0;
    WebPanel4.Top := 60;
    WebPanel4.Width := 640;
    WebPanel4.Height := 53;
    WebPanel4.Align := alTop;
    WebPanel4.ChildOrder := 2;
    WebPanel4.Color := clSilver;
    WebPanel4.TabOrder := 2;
    WebSpeedButton1.SetParentComponent(WebPanel4);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 16;
    WebSpeedButton1.Top := 6;
    WebSpeedButton1.Width := 40;
    WebSpeedButton1.Height := 40;
    WebSpeedButton1.Caption := '<<';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 0;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    WebSpeedButton2.SetParentComponent(WebPanel4);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 62;
    WebSpeedButton2.Top := 6;
    WebSpeedButton2.Width := 40;
    WebSpeedButton2.Height := 40;
    WebSpeedButton2.Caption := '<';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 1;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    WebSpeedButton3.SetParentComponent(WebPanel4);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 108;
    WebSpeedButton3.Top := 6;
    WebSpeedButton3.Width := 40;
    WebSpeedButton3.Height := 40;
    WebSpeedButton3.Caption := '>';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.TabOrder := 2;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    WebSpeedButton4.SetParentComponent(WebPanel4);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 154;
    WebSpeedButton4.Top := 6;
    WebSpeedButton4.Width := 40;
    WebSpeedButton4.Height := 40;
    WebSpeedButton4.Caption := '>>';
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.TabOrder := 3;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    WebSpeedButton5.SetParentComponent(WebPanel4);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 200;
    WebSpeedButton5.Top := 6;
    WebSpeedButton5.Width := 40;
    WebSpeedButton5.Height := 40;
    WebSpeedButton5.Caption := '+';
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.TabOrder := 4;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
    dgCountry.SetParentComponent(WebPanel1);
    dgCountry.Name := 'dgCountry';
    dgCountry.Left := 0;
    dgCountry.Top := 113;
    dgCountry.Width := 640;
    dgCountry.Height := 307;
    dgCountry.Align := alClient;
    dgCountry.ParentDoubleBuffered := False;
    dgCountry.DoubleBuffered := True;
    dgCountry.TabOrder := 3;
    dgCountry.ShowAcceleratorChar := False;
    dgCountry.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgCountry.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgCountry.Header.VisualGrouping.Layout.Font.Height := -12;
    dgCountry.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgCountry.Header.VisualGrouping.Layout.Font.Style := [];
    dgCountry.Adapter := dgdbaCountry;
    dgCountry.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgCountry.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgCountry.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgCountry.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgCountry.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgCountry.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgCountry.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgCountry.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgCountry.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgCountry.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgCountry.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgCountry.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgCountry.CellAppearance.BandLayout.Font.Height := -12;
    dgCountry.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgCountry.CellAppearance.BandLayout.Font.Style := [];
    dgCountry.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgCountry.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgCountry.CellAppearance.FixedLayout.Font.Height := -12;
    dgCountry.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgCountry.CellAppearance.FixedLayout.Font.Style := [];
    dgCountry.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgCountry.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgCountry.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgCountry.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgCountry.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgCountry.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgCountry.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgCountry.CellAppearance.FocusedLayout.Font.Height := -12;
    dgCountry.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgCountry.CellAppearance.FocusedLayout.Font.Style := [];
    dgCountry.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgCountry.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgCountry.CellAppearance.GroupLayout.Font.Height := -12;
    dgCountry.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgCountry.CellAppearance.GroupLayout.Font.Style := [];
    dgCountry.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgCountry.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgCountry.CellAppearance.NormalLayout.Font.Height := -12;
    dgCountry.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgCountry.CellAppearance.NormalLayout.Font.Style := [];
    dgCountry.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgCountry.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgCountry.CellAppearance.SelectedLayout.Font.Height := -12;
    dgCountry.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgCountry.CellAppearance.SelectedLayout.Font.Style := [];
    dgCountry.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgCountry.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgCountry.CellAppearance.SummaryLayout.Font.Height := -12;
    dgCountry.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgCountry.CellAppearance.SummaryLayout.Font.Style := [];
    dgCountry.ColumnCount := 2;
    dgCountry.Columns.Clear;
    with dgCountry.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'No';
      Name := 'no';
    end;
    with dgCountry.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Country Name';
      Name := 'Name';
    end;
    dgCountry.Designer := False;
    dgCountry.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgCountry.FilterAppearance.Font.Color := clWindowText;
    dgCountry.FilterAppearance.Font.Height := -12;
    dgCountry.FilterAppearance.Font.Name := 'Segoe UI';
    dgCountry.FilterAppearance.Font.Style := [];
    dgCountry.Icons.ExpandIcon.LoadFromFile('Country.WebPanel1.dgCountry.Icons.ExpandIcon.svg');
    dgCountry.Icons.CollapseIcon.LoadFromFile('Country.WebPanel1.dgCountry.Icons.CollapseIcon.svg');
    dgCountry.Icons.FilterIcon.LoadFromFile('Country.WebPanel1.dgCountry.Icons.FilterIcon.svg');
    dgCountry.Icons.FilterActiveIcon.LoadFromFile('Country.WebPanel1.dgCountry.Icons.FilterActiveIcon.svg');
    dgCountry.Icons.FilterClearIcon.LoadFromFile('Country.WebPanel1.dgCountry.Icons.FilterClearIcon.svg');
    dgCountry.Icons.FilterTypeIcon.LoadFromFile('Country.WebPanel1.dgCountry.Icons.FilterTypeIcon.svg');
    dgCountry.Icons.SortAscendingIcon.LoadFromFile('Country.WebPanel1.dgCountry.Icons.SortAscendingIcon.svg');
    dgCountry.Icons.SortDescendingIcon.LoadFromFile('Country.WebPanel1.dgCountry.Icons.SortDescendingIcon.svg');
    dgCountry.Icons.CloseIcon.LoadFromFile('Country.WebPanel1.dgCountry.Icons.CloseIcon.svg');
    SetEvent(dgCountry, Self, 'OnCellClick', 'dgCountryCellClick');
    dgCountry.RowCount := 1;
    dgdbaCountry.SetParentComponent(dgCountry);
    dgdbaCountry.Name := 'dgdbaCountry';
    dgdbaCountry.Left := 278;
    dgdbaCountry.Top := 56;
    dgdbaCountry.Width := 26;
    dgdbaCountry.Height := 26;
    dgdbaCountry.Visible := True;
    dgdbaCountry.Columns.Clear;
    with dgdbaCountry.Columns.Add do
    begin
      FieldName := 'no';
      AutoCreated := False;
    end;
    with dgdbaCountry.Columns.Add do
    begin
      FieldName := 'Name';
      Header := 'Country Name';
      AutoCreated := False;
    end;
    dgdbaCountry.DataSource := dsCountry;
    wcCountry.SetParentComponent(Self);
    wcCountry.Name := 'wcCountry';
    wcCountry.Connection := dmData.dbConnect;
    wcCountry.Left := 88;
    wcCountry.Top := 169;
    wdsCountry.SetParentComponent(Self);
    wdsCountry.Name := 'wdsCountry';
    wdsCountry.Connection := dmData.dbConnect;
    wdsCountry.Left := 152;
    wdsCountry.Top := 169;
    wdsCountryno.SetParentComponent(wdsCountry);
    wdsCountryno.Name := 'wdsCountryno';
    wdsCountryno.FieldName := 'no';
    wdsCountryName.SetParentComponent(wdsCountry);
    wdsCountryName.Name := 'wdsCountryName';
    wdsCountryName.FieldName := 'Name';
    dsCountry.SetParentComponent(Self);
    dsCountry.Name := 'dsCountry';
    dsCountry.DataSet := wdsCountry;
    dsCountry.Left := 216;
    dsCountry.Top := 169;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    TMSFNCBitmapContainer1.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebSpeedButton6.AfterLoadDFMValues;
    WebSpeedButton7.AfterLoadDFMValues;
    edtCountryPC.AfterLoadDFMValues;
    WebSpeedButton8.AfterLoadDFMValues;
    WebSpeedButton9.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    dgCountry.AfterLoadDFMValues;
    dgdbaCountry.AfterLoadDFMValues;
    wcCountry.AfterLoadDFMValues;
    wdsCountry.AfterLoadDFMValues;
    wdsCountryno.AfterLoadDFMValues;
    wdsCountryName.AfterLoadDFMValues;
    dsCountry.AfterLoadDFMValues;
  end;
end;

end.